import { VocalEffects, VocalEffectsList, vocalPresets } from 'constants/vocalPresets';
import {
  Container,
  Title,
  SubTitle,
  BoxEffectContainer,
  GoBackContaier,
} from './EffectsPage.style';
import { BoxEffect } from 'components/b2b/BoxEffect/BoxEffect';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedVocalEffect } from '@redux/featureFlags';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import { ArrowBackIos } from '@mui/icons-material';
import analytics from 'lib/analytics';
import { useSelector } from 'react-redux';
import { selectedVocalEffectSelector } from '@redux/featureFlags/selector';

export function EffectsPage() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [m_output1, set_m_output1] = useState<any>(null);
  const currentVocalEffect = useSelector(selectedVocalEffectSelector);

  let m = null;

  const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  const onMIDISuccess = async (midiAccess: any) => {
    m = midiAccess;
    const outputs = m.outputs;

    const iteratorOutputs = outputs.values();

    set_m_output1(iteratorOutputs.next().value);

    for (const preset of vocalPresets.DEFAULT) {
      iteratorOutputs.next().value.send(preset, 0x7f);
      await delay(2);
    }
  };

  const onMIDIFailure = () => {
    console.log('Could not access your MIDI devices.');
  };

  const handleToggleVoiceModification = async (effect: VocalEffects) => {
    dispatch(setSelectedVocalEffect(effect));
    for (const preset of vocalPresets[effect]) {
      m_output1?.send(preset, 0x7f);
      await delay(2);
    }
  };

  const goBack = () => {
    analytics.track('VocalEffect_back_btn');
    navigate(-1);
  };

  useEffect(() => {
    if (!m_output1) {
      navigator.requestMIDIAccess().then(onMIDISuccess, onMIDIFailure);
    }
    if (m_output1 && currentVocalEffect !== VocalEffects.DEFAULT) {
      handleToggleVoiceModification(VocalEffects.DEFAULT);
    }
  }, [m_output1]);

  return (
    <Container>
      <GoBackContaier onClick={goBack}>
        <ArrowBackIos fontSize='small' />
        <FormattedMessage id='home.back' />
      </GoBackContaier>
      <Title>
        <FormattedMessage id='control-bar.vocal-effects' />
      </Title>
      <SubTitle>
        <FormattedMessage id='voice-effects.title' />
      </SubTitle>

      <BoxEffectContainer>
        {VocalEffectsList.map(
          (effect) =>
            effect.icon && (
              <div key={effect.name}>
                <BoxEffect
                  effect={effect.name}
                  color={effect.color}
                  Icon={effect.icon}
                  translationId={effect.translationId}
                  onClick={handleToggleVoiceModification}
                />
              </div>
            ),
        )}
      </BoxEffectContainer>
    </Container>
  );
}
